import { Box, Container, Typography, Card } from '@mui/material';
import { GoogleMap, LoadScript, Marker } from '@react-google-maps/api';
import { useTheme } from '@mui/material/styles';
import ContactForm from './contactform';
import { useMediaQuery } from '@mui/material';

const darkStyles = [
    { elementType: "geometry", stylers: [{ color: "#242f3e" }] },
    { elementType: "labels.text.stroke", stylers: [{ color: "#242f3e" }] },
    { elementType: "labels.text.fill", stylers: [{ color: "#746855" }] },
    {
      featureType: "administrative.locality",
      elementType: "labels.text.fill",
      stylers: [{ color: "#d59563" }],
    },
    {
      featureType: "poi",
      elementType: "labels.text.fill",
      stylers: [{ color: "#d59563" }],
    },
    {
      featureType: "poi.park",
      elementType: "geometry",
      stylers: [{ color: "#263c3f" }],
    },
    {
      featureType: "poi.park",
      elementType: "labels.text.fill",
      stylers: [{ color: "#6b9a76" }],
    },
    {
      featureType: "road",
      elementType: "geometry",
      stylers: [{ color: "#38414e" }],
    },
    {
      featureType: "road",
      elementType: "geometry.stroke",
      stylers: [{ color: "#212a37" }],
    },
    {
      featureType: "road",
      elementType: "labels.text.fill",
      stylers: [{ color: "#9ca5b3" }],
    },
    {
      featureType: "road.highway",
      elementType: "geometry",
      stylers: [{ color: "#746855" }],
    },
    {
      featureType: "road.highway",
      elementType: "geometry.stroke",
      stylers: [{ color: "#1f2835" }],
    },
    {
      featureType: "road.highway",
      elementType: "labels.text.fill",
      stylers: [{ color: "#f3d19c" }],
    },
    {
      featureType: "transit",
      elementType: "geometry",
      stylers: [{ color: "#2f3948" }],
    },
    {
      featureType: "transit.station",
      elementType: "labels.text.fill",
      stylers: [{ color: "#d59563" }],
    },
    {
      featureType: "water",
      elementType: "geometry",
      stylers: [{ color: "#17263c" }],
    },
    {
      featureType: "water",
      elementType: "labels.text.fill",
      stylers: [{ color: "#515c6d" }],
    },
    {
      featureType: "water",
      elementType: "labels.text.stroke",
      stylers: [{ color: "#17263c" }],
    },
  ];

const Map = () => {
  const theme = useTheme();
  const downMd = useMediaQuery((theme) => theme.breakpoints.down('md'));

  return (
    <Box
      sx={{
        position: 'relative',
        width: '100%',
        minHeight: '50vh',
        }}
        >
        <a id="contact" />
        <div style={{ position: downMd ? 'relative' : 'absolute', minHeight: '50vh', height: '100%', width: '100%' }}>
        <LoadScript googleMapsApiKey="AIzaSyA2GO9LHJX5K_C0BMyNPb462oQl32N0oNk">
            <GoogleMap
            mapContainerStyle={{
            width: '100%',
            height: '100%',
            position: 'absolute',
            }}
            options={{
            styles: theme.palette.mode === 'dark' ? darkStyles : undefined
            }}
            center={{ lat: 17.132578, lng: -61.846061 }}
            zoom={15}
        >
            <Marker
            position={{ lat: 17.134178, lng: -61.853061 }}
            label={{ text: 'SwissX Island', color: 'red' }}
            icon={{
                path: "M 0 0 L -1 1 L -10 15 L -22 37 L -27 46 L -31 56 L -36 62 L -41 75 L -63 120 L -67 131 L -73 143 L -81 160 L -88 176 L -98 198 L -109 220 L -116 236 " +
                    "L -126 258 L -138 282 L -142 292 L -148 305 L -158 326 L -162 336 L -169 351 L -181 376 L -189 394 L -196 409 L -209 436 L -214 448 L -220 461 " +
                    "L -228 478 L -236 494 L -238 501 L -246 518 L -250 524 L -253 525 L -273 517 L -297 508 L -308 503 L -317 500 L -333 493 L -348 487 L -368 480 " + 
                    "L -387 472 L -433 453 L -468 439 L -496 428 L -515 420 L -533 413 L -541 410 L -556 404 L -575 396 L -605 384 L -620 379 L -628 375 L -640 371 " + 
                    "L -648 367 L -660 363 L -670 358 L -702 346 L -712 343 L -725 337 L -740 331 L -759 324 L -761 325 L -761 349 L -758 356 L -751 370 L -745 390 " +
                    "L -738 404 L -734 414 L -730 425 L -720 449 L -713 468 L -702 494 L -695 513 L -685 539 L -674 564 L -669 578 L -662 595 L -657 609 L -652 619 " +
                    "L -646 635 L -634 664 L -626 685 L -618 705 L -613 718 L -609 729 L -602 744 L -598 754 L -593 769 L -586 785 L -580 800 L -573 817 L -568 828 " +
                    "L -565 838 L -562 843 L -561 852 L -555 857 L -544 864 L -530 869 L -516 876 L -507 878 L -491 886 L -474 895 L -462 899 L -457 904 L -458 907 " +
                    "L -463 910 L -482 920 L -498 929 L -515 939 L -538 951 L -553 960 L -585 976 L -593 982 L -613 992 L -632 1002 L -648 1010 L -657 1016 L -683 1030 " +
                    "L -699 1040 L -715 1049 L -728 1057 L -740 1064 L -748 1069 L -763 1077 L -780 1087 L -796 1095 L -816 1106 L -824 1113 L -824 1116 L -807 1123 " + 
                    "L -794 1131 L -762 1147 L -748 1155 L -722 1167 L -708 1175 L -692 1183 L -684 1188 L -652 1204 L -644 1209 L -634 1215 L -568 1248 L -560 1253 " +
                    "L -550 1259 L -488 1290 L -470 1301 L -463 1301 L -461 1304 L -456 1308 L -449 1309 L -441 1303 L -425 1297 L -406 1288 L -389 1279 L -370 1270 " +
                    "L -357 1265 L -345 1259 L -317 1246 L -318 1271 L -320 1275 L -322 1282 L -322 1291 L -325 1295 L -326 1315 L -327 1316 L -330 1321 L -330 1328 " +
                    "L -332 1329 L -334 1333 L -334 1351 L -337 1353 L -338 1368 L -341 1371 L -342 1384 L -345 1387 L -346 1407 L -350 1412 L -350 1425 L -353 1428 " +
                    "L -354 1444 L -355 1448 L -357 1448 L -358 1454 L -358 1463 L -361 1466 L -362 1480 L -365 1487 L -365 1501 L -363 1501 L -354 1497 L -348 1497 " +
                    "L -341 1496 L -338 1493 L -329 1492 L -326 1490 L -313 1488 L -311 1486 L -301 1484 L -296 1481 L -286 1481 L -280 1478 L -274 1477 L -267 1474 " +
                    "L -254 1472 L -250 1469 L -241 1468 L -235 1465 L -224 1464 L -220 1462 L -214 1461 L -208 1459 L -197 1456 L -192 1453 L -184 1453 L -172 1449 " + 
                    "L -164 1447 L -164 1445 L -157 1445 L -150 1444 L -148 1442 L -138 1441 L -132 1439 L -127 1437 L -119 1437 L -115 1434 L -106 1415 L -97 1388 " +
                    "L -93 1378 L -86 1359 L -70 1315 L -60 1288 L -53 1268 L -49 1258 L -43 1242 L -36 1224 L -32 1211 L -26 1196 L -17 1170 L -12 1158 L -6 1154 " +
                    "L -6 1309 L -8 1309 L -6 1341 L -6 1458 L -8 1458 L -10 1461 L -9 1488 L -6 1492 L -2 1493 L 29 1493 L 31 1492 L 31 1338 L 27 1335 L 27 1175 " +
                    "L 23 1171 L 24 1155 L 28 1157 L 35 1170 L 50 1210 L 61 1239 L 69 1258 L 79 1285 L 88 1305 L 91 1317 L 97 1330 L 102 1343 L 109 1361 L 114 1374 " +
                    "L 122 1394 L 126 1405 L 134 1424 L 138 1431 L 148 1436 L 158 1437 L 164 1440 L 179 1443 L 197 1448 L 210 1450 L 221 1453 L 230 1456 L 246 1459 " +
                    "L 280 1468 L 301 1473 L 323 1478 L 328 1480 L 342 1482 L 356 1487 L 368 1490 L 372 1492 L 381 1493 L 391 1495 L 391 1488 L 388 1483 L 387 1469 " +
                    "L 384 1465 L 383 1450 L 379 1448 L 379 1434 L 375 1430 L 375 1417 L 372 1415 L 371 1410 L 371 1398 L 367 1395 L 367 1379 L 363 1374 L 363 1364 " +
                    "L 362 1362 L 359 1361 L 359 1346 L 355 1342 L 355 1331 L 351 1326 L 351 1313 L 347 1306 L 347 1294 L 344 1292 L 343 1289 L 343 1279 L 340 1276 " +
                    "L 339 1272 L 339 1263 L 338 1261 L 335 1254 L 333 1248 L 332 1241 L 339 1241 L 346 1243 L 388 1264 L 397 1266 L 404 1270 L 417 1275 L 446 1289 " +
                    "L 462 1297 L 479 1297 L 485 1293 L 490 1290 L 507 1281 L 516 1275 L 522 1273 L 530 1268 L 553 1256 L 558 1252 L 567 1248 L 578 1242 L 593 1234 " +
                    "L 608 1225 L 629 1214 L 637 1209 L 648 1203 L 667 1193 L 676 1187 L 685 1184 L 696 1177 L 713 1168 L 720 1162 L 729 1160 L 734 1156 L 743 1151 L 756 1143 L 781 1130 L 789 1125 L 798 1120 L 814 1112 L 829 1104 L 841 1095 L 841 1092 L 824 1083 L 808 1075 L 793 1067 L 778 1058 L 732 1035 L 720 1028 L 701 1019 L 680 1007 L 640 987 L 626 979 L 616 975 L 595 963 L 584 959 L 578 954 L 520 925 L 502 914 L 494 912 L 489 909 L 476 900 L 475 895 L 480 893 L 501 882 L 510 880 L 529 870 L 558 856 L 574 848 L 578 840 L 582 830 L 591 804 L 602 775 L 613 742 L 619 728 L 628 704 L 639 672 L 649 646 L 663 608 L 670 588 L 678 567 L 687 540 L 693 525 L 699 508 L 704 496 L 712 472 L 717 461 L 724 441 L 735 412 L 742 394 L 744 384 L 747 378 L 753 362 L 758 350 L 770 316 L 771 308 L 765 308 L 746 315 L 730 323 L 721 325 L 716 328 L 695 336 L 690 339 L 680 341 L 678 343 L 669 345 L 655 352 L 650 355 L 641 357 L 636 360 L 619 367 L 607 372 L 586 380 L 562 390 L 553 393 L 543 398 L 533 401 L 523 406 L 513 409 L 502 415 L 493 417 L 483 422 L 455 433 L 439 440 L 434 443 L 424 445 L 422 447 L 413 449 L 387 462 L 381 464 L 373 467 L 356 473 L 354 475 L 345 477 L 334 483 L 322 486 L 314 491 L 295 498 L 286 501 L 275 506 L 262 512 L 249 512 L 246 510 L 219 456 L 215 446 L 207 430 L 190 394 L 179 371 L 173 359 L 162 336 L 151 312 L 143 296 L 130 269 L 124 256 L 106 218 L 86 177 L 75 152 L 53 108 L 44 89 L 32 62 L 11 20 L 4 4 L 0 0 z M 38 657 L 52 657 L 53 659 L 56 709 L 62 807 L 62 815 L 123 814 L 143 813 L 165 813 L 187 814 L 222 819 L 225 821 L 229 861 L 231 911 L 231 952 L 230 953 L 174 953 L 107 949 L 76 947 L 67 945 L 70 987 L 75 1056 L 77 1072 L 77 1078 L 62 1086 L 39 1097 L 21 1105 L -1 1106 L -15 1101 L -49 1085 L -59 1080 L -62 1077 L -65 1015 L -68 952 L -69 951 L -105 952 L -149 955 L -169 958 L -199 959 L -222 959 L -223 958 L -224 943 L -225 880 L -227 830 L -227 826 L -196 823 L -152 821 L -120 820 L -89 820 L -71 821 L -73 774 L -74 752 L -76 669 L -71 667 L -56 664 L -17 660 L 5 658 L 38 657 z",
                scale: 0.03,
                fillColor: '#c2262a',
                fillOpacity: 1
            }}
            />
        </GoogleMap>      
        </LoadScript>
        </div>
        <Container
        sx={{
            position: 'relative',
            zIndex: 1,
            height: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-end',
            p: 4
        }}
        >
        <Card 
            sx={{ 
            p: 4, 
            width: '100%', 
            maxWidth: 500,
            backgroundColor: 'rgba(255, 255, 255, 0.9)'
            }}
        >
            <Typography variant="h4" gutterBottom>
            Contact Us
            </Typography>
            <ContactForm />
        </Card>
        </Container>
        </Box>
    );
};

export default Map;
